import * as React from 'react';
import { useTranslations } from 'next-intl';

import { HeaderMenuLinksDesktop } from './header-menu-links-desktop';
import { HeaderMenuLinksMobile } from './header-menu-links-mobile';

const getMenuSections = (t: ReturnType<typeof useTranslations>) => [
  {
    label: t('header:links:engine'),
    href: 'https://docs.unity3d.com/Manual/',
    items: [
      {
        label: t('header:links:engine:unity-manual'),
        href: 'https://docs.unity3d.com/Manual/',
      },
      {
        label: t('header:links:engine:scripting-api-reference'),
        href: 'https://docs.unity3d.com/ScriptReference/',
      },
      {
        label: t('header:links:engine:packages'),
        href: 'https://docs.unity3d.com/Manual/PackagesList.html',
      },
      {
        label: t('header:links:engine:multiplayer-center'),
        href: 'https://docs.unity3d.com/Manual/multiplayer.html',
      },
      {
        label: t('header:links:engine:tools'),
      },
      {
        label: t('header:links:engine:speedtree'),
        href: 'https://store.speedtree.com/support/documentation/',
      },
    ],
  },
  {
    label: t('header:links:services'),
    href: 'https://docs.unity.com/ugs',
    items: [
      {
        label: t('header:links:services:accounts'),
      },
      {
        label: t('header:links:services:authentication'),
        href: 'https://docs.unity.com/ugs/en-us/manual/authentication/manual/overview',
      },
      {
        label: t('header:links:services:cloud-save'),
        href: 'https://docs.unity.com/ugs/en-us/manual/cloud-save/manual',
      },
      {
        label: t('header:links:services:content-management'),
      },
      {
        label: t('header:links:services:cloud-code'),
        href: 'https://docs.unity.com/ugs/en-us/manual/cloud-code/manual',
      },
      {
        label: t('header:links:services:cloud-content-delivery'),
        href: 'https://docs.unity.com/ugs/en-us/manual/ccd/manual/UnityCCD',
      },
      {
        label: t('header:links:services:economy'),
        href: 'https://docs.unity.com/ugs/en-us/manual/economy/manual',
      },
      {
        label: t('header:links:services:remote-config'),
        href: 'https://docs.unity.com/ugs/en-us/manual/remote-config/manual/WhatsRemoteConfig',
      },
      {
        label: 'PLACEHOLDER',
      },
      {
        label: 'PLACEHOLDER',
      },
      {
        label: t('header:links:services:devops'),
      },
      {
        label: t('header:links:services:build-automation'),
        href: 'https://docs.unity.com/ugs/en-us/manual/devops/manual/build-automation/overview',
      },
      {
        label: t('header:links:services:unity-version-control'),
        href: 'https://docs.unity.com/ugs/en-us/manual/devops/manual/unity-version-control',
      },
      {
        label: t('header:links:services:multiplayer'),
      },
      {
        label: t('header:links:services:multiplayer-center'),
        href: 'https://docs.unity3d.com/Manual/multiplayer.html',
      },
      {
        label: t('header:links:services:game-server-hosting'),
        href: 'https://docs.unity.com/ugs/en-us/manual/game-server-hosting/manual/welcome',
      },
      {
        label: t('header:links:services:lobby'),
        href: 'https://docs.unity.com/ugs/en-us/manual/lobby/manual/unity-lobby-service',
      },
      {
        label: t('header:links:services:matchmaker'),
        href: 'https://docs.unity.com/ugs/en-us/manual/matchmaker/manual/matchmaker-overview',
      },
      {
        label: t('header:links:services:relay'),
        href: 'https://docs.unity.com/ugs/en-us/manual/relay/manual/introduction',
      },
      {
        label: 'PLACEHOLDER',
      },
      {
        label: t('header:links:services:player-engagement'),
      },
      {
        label: t('header:links:services:analytics'),
        href: 'https://docs.unity.com/ugs/en-us/manual/analytics/manual/overview',
      },
      {
        label: t('header:links:services:game-overrides'),
        href: 'https://docs.unity.com/ugs/en-us/manual/game-overrides/manual/overview',
      },
      {
        label: t('header:links:services:push-notifications'),
        href: 'https://docs.unity.com/ugs/en-us/manual/push-notifications/manual/overview',
      },
      {
        label: t('header:links:services:community'),
      },
      {
        label: t('header:links:services:friends'),
        href: 'https://docs.unity.com/ugs/en-us/manual/friends/manual/welcome',
      },
      {
        label: t('header:links:services:leaderboards'),
        href: 'https://docs.unity.com/ugs/en-us/manual/leaderboards/manual/leaderboards',
      },
      {
        label: t('header:links:services:voice-text-chat'),
        href: 'https://docs.unity.com/ugs/en-us/manual/vivox-unity/manual/Unity/Unity',
      },
      {
        label: t('header:links:services:crash-reporting'),
      },
      {
        label: t('header:links:services:cloud-diagnostics'),
        href: 'https://docs.unity.com/ugs/en-us/manual/cloud-diagnostics/manual/CloudDiagnostics/WelcometoCloudDiagnostics',
      },
    ],
  },
  {
    label: t('header:links:grow'),
    href: 'https://docs.unity.com/grow',
    items: [
      {
        label: t('header:links:grow:monetize'),
      },
      {
        label: t('header:links:grow:unity-ads-monetization'),
        href: 'https://docs.unity.com/grow/en-us/ads',
      },
      {
        label: t('header:links:grow:ads-monetization-dashboard'),
        href: 'https://docs.unity.com/grow/en-us/dashboard',
      },
      {
        label: t('header:links:grow:levelplay-from-unity'),
        href: 'https://developers.is.com/levelplay-platform/',
      },
      {
        label: t('header:links:grow:tapjoy-from-unity'),
        href: 'https://dev.tapjoy.com',
      },
      {
        label: t('header:links:grow:acquire'),
      },
      {
        label: t('header:links:grow:unity-ads-user-acquisition'),
        href: 'https://docs.unity.com/grow/en-us/acquire',
      },
      {
        label: t('header:links:grow:ironsource-ads-user-acquisition'),
        href: 'https://developers.is.com/user-acquisition/',
      },
      {
        label: t('header:links:grow:unity-exchange'),
        href: 'https://docs.unity.com/grow/en-us/exchange',
      },
      {
        label: t('header:links:grow:unity-playworks'),
        href: 'https://docs.lunalabs.io',
      },
    ],
  },
  {
    label: t('header:links:industry'),
    href: '/cloud',
    items: [
      {
        label: t('header:links:industry:pixyz'),
        href: 'https://pixyz-software.com/documentations/',
      },
      {
        label: t('header:links:industry:asset-manager'),
        href: '/cloud/asset-manager',
      },
      {
        label: t('header:links:industry:cloud-tools'),
        href: '/cloud/creator-sdks',
      },
    ],
  },
  {
    label: t('header:links:support'),
    href: 'https://unity.com/support-services',
  },
];

export interface HeaderMenuLinksProps {
  variant: 'mobile' | 'desktop';
  container?: HTMLDivElement | null;
  open?: boolean;
}

export const HeaderMenuLinks = ({ variant = 'desktop', container, open }: HeaderMenuLinksProps) => {
  const t = useTranslations();
  const menuSections = getMenuSections(t);

  if (variant === 'desktop') {
    return menuSections.map(({ label, href, items }) => (
      <HeaderMenuLinksDesktop key={label} label={label} href={href} items={items} container={container} />
    ));
  }

  return <HeaderMenuLinksMobile open={open} sections={menuSections} />;
};
